/**
 * Toolkit INIT ALL
 */

//
// Do not add any JS here, it's loaded in all the pages. Make a dynamic import. @see MATCH-3823
//

// Elements
import version from '@tools/version/version';
import deviceDetect from '@tools/device-detect';
import lazy from '@tools/lazyloading';
import { initIntercom } from '@elements/intercom';
import userAuth from '@tools/user/auth';

// Atoms import
import loadAtoms from '@atoms/load-atoms';

// Molecules import
import banner from '@molecules/banner';
import favoriteBusHandler from '@molecules/favorite-bus-handler';
import proposalBusHandler from '@molecules/proposal-bus-handler';
import sliderManager from '@molecules/slider-manager';

// Organism import
import header from '@organisms/header';
import user from '@organisms/user';
import stickyHeader from '@organisms/sticky-header';

// Pages import
import profileManage from '@pages/profile-manage';
import contactUs from '@pages/contact-us';
import offerPage from '@pages/offer';
import createOffer from '@pages/create-offer';
import editOffer from '@pages/edit-offer';
import vueInit from '@pages/vue-init';
import { selectionItemsApp } from '@pages/offer/selection-items';
import about from '@pages/about';
import inbox from '@pages/inbox';
import invoice from '@pages/invoice';
import dealDashboard from '@pages/deal-dashboard';
import leads from '@pages/leads';
import address from '@pages/address';
import addressContact from '@pages/address-contact';
import addressDetails from '@pages/address-details';
import adaf from '@pages/adaf';
import idealLocation from '@pages/ideal-location';
import bigTeam from '@pages/bigteam';
import deobfuscate from '@organisms/deobfuscate';
import offerContactForm from '@pages/offer-contact-form';
import guidedSearch from '@pages/guided-search';
import officeChooser from '@pages/office-chooser';
import onboarding from '@pages/organization-onboarding';
import spaceDetails from '@organisms/space-details/space-details';
import staticGoogleMap from '@organisms/page-details/static-google-map';
import pageSpaceContactForm from '@pages/page-space-contact-form';
import pageBrand from '@pages/page-brand';
import brandDetails from '@organisms/brand-details/brand-details';
import { pagination } from '@atoms/pagination';
import subscriptions from '@pages/subscriptions';
import { favoriteButtonLoader } from '@organisms/favoriteButtonLoader';
import nav from './layout/nav.ts';

// Load styles
import '../styles/_base.scss';
import '../styles/_vendor.scss';
import '../styles/_atoms.scss';
import '../styles/_molecules.scss';
import '../styles/_organisms.scss';
import '../styles/_pages.scss';

// Elements
version();
deviceDetect();

// Atoms usage
lazy();
loadAtoms();

// Molecules usage
banner();
favoriteBusHandler();
proposalBusHandler();
// a init que quand necessaire
sliderManager();
user();
deobfuscate();
onboarding();

// Organisms usage
header();
window.addEventListener('load', stickyHeader);

if (document.fonts !== undefined) {
  document.fonts.ready.then(() => {
    document.body.classList.add('fonts-loaded');
  });
}

nav();

profileManage(); // bundle

if (document.querySelector('#home')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "homepage" */ '@organisms/home'
  );
}

if (document.querySelector('.guide-article')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "guide" */ '@pages/guide'
  );
}

if (document.querySelector('.carousel')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "carousel" */ '@molecules/carousel'
  );
}

if (document.querySelector('#app-gallery')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "gallery" */ '@organisms/gallery'
  );
}

if (document.querySelector('.footer-columns')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "footer" */ '@organisms/footerFull'
  );
}

if (document.querySelector('#offer-statistics')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "statistics" */ '@organisms/offer/statistics'
  );
}
if (document.getElementById('holiday-banner')) {
  // eslint-disable-next-line import/extensions
  import(/* webpackChunkName: "banner" */ '@molecules/holiday-banner.js');
}

if (document.querySelector('.offer-card')) {
  // eslint-disable-next-line import/extensions
  import(/* webpackChunkName: "offer-card" */ '@components-molecules/offer-card');
}

contactUs(); // bundle
offerPage(); // bundle
createOffer(); // bundle
editOffer(); // bundle
vueInit();
selectionItemsApp(); // bundle
about(); // bundle
inbox(); // bundle
invoice(); // bundle
dealDashboard(); // bundle
leads(); // bundle
subscriptions(); // bundle
address(); // bundle
addressContact(); // bundle
addressDetails(); // bundle
adaf(); // bundle
idealLocation(); // bundle
bigTeam(); // bundle
offerContactForm();
guidedSearch(); // bundle
officeChooser(); // bundle
spaceDetails(); // bundle
pageBrand(); // bundle
pageSpaceContactForm(); // bundle
staticGoogleMap(); // bundle
brandDetails();
pagination();
favoriteButtonLoader();
initIntercom();
